import { useCallback } from 'react';
import { QuestProgress } from 'shared/interfaces/redirect/quest-progress.interface';
import { ToastType } from 'src/components/Toast/toast-type.enum';
import { useQuestsContext } from 'src/contexts/QuestsContext/QuestsContext';
import { useTranslationByKey } from 'src/hooks/use-translation-by-key';
import { showToast } from 'src/utils/toast-utils';

export const useQuestProgressNotification = () => {
  const t = useTranslationByKey('PAGES.QUESTS');
  const { refreshQuests } = useQuestsContext();

  return useCallback(
    (questProgress?: QuestProgress | null): boolean => {
      const questsUpdated = questProgress?.questsUpdated ?? 0;
      const questsCompleted = questProgress?.questsCompleted ?? 0;
      const newQuestsUnlocked = questProgress?.newQuestsUnlocked ?? 0;

      if (questsCompleted > 0) {
        showToast(
          questsCompleted === 1
            ? t('QUEST_COMPLETE_NOTIFICATION')
            : t('QUESTS_COMPLETE_NOTIFICATION', { count: questsCompleted }),
          ToastType.Success
        );
      }

      if (questsUpdated > 0) {
        showToast(
          questsUpdated === 1
            ? t('QUEST_PROGRESS_NOTIFICATION')
            : t('QUESTS_PROGRESS_NOTIFICATION', { count: questsUpdated }),
          ToastType.Success
        );
      }

      if (newQuestsUnlocked > 0) {
        showToast(
          newQuestsUnlocked === 1
            ? t('QUEST_UNLOCKED_NOTIFICATION')
            : t('QUESTS_UNLOCKED_NOTIFICATION', { count: newQuestsUnlocked }),
          ToastType.Success
        );
      }

      const hasQuestUpdate = questsUpdated > 0 || questsCompleted > 0 || newQuestsUnlocked > 0;
      if (hasQuestUpdate) {
        void refreshQuests();
      }

      return hasQuestUpdate;
    },
    [refreshQuests, t]
  );
};
